export class StakeholderCcDto {
  id: string;
  name: string;
  address: string;

  public constructor(init?: Partial<StakeholderCcDto>) {
    Object.assign(this, init);
  }
}
